/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mode_VoiceInputs */



/**
* | output |
* | --- |
* | "Voice" |
*
* @param {Practice_Session_Mode_VoiceInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mode_voice = /** @type {((inputs?: Practice_Session_Mode_VoiceInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mode_VoiceInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Spraak")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voix")
	return /** @type {LocalizedString} */ ("Voice")
});